import React from "react";
import Reveal from "./reveal";
import Button from "./button";

/** Full-width closing call-to-action. */
export default function CTABand({ kicker = "Ready to Grow?", title, text, label = "Book a Free Consultation", to = "/contact" }) {
  return (
    <section className="final-cta">
      <div className="container">
        <Reveal className="cta-box">
          <div>
            <div className="kicker">{kicker}</div>
            <h2>{title}</h2>
            {text && <p>{text}</p>}
          </div>
          <Button to={to} variant="light">{label}</Button>
        </Reveal>
      </div>
    </section>
  );
}
